import React, { useEffect, useState } from "react";
import './DataTableEcommerce.css';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import useForm from "lib/useForm";
import { Col, Row } from "reactstrap";

const DataTableEcommerce = ({ columns, data, setData, readOnly, checkAll, recalculaMargemMkp, onlyChecked, setColumn, gravaPosicaoColunas }) => {

  const countSubstr = (string, subString, allowOverlapping) => {
    string += "";
    subString += "";
    if (subString.length <= 0) return (string.length + 1);

    var n = 0,
      pos = 0,
      step = allowOverlapping ? 1 : subString.length;

    while (true) {
      pos = string.indexOf(subString, pos);
      if (pos >= 0) {
        ++n;
        pos += step;
      } else break;
    }
    return n;
  }


  const onChangeInput = (e, idx) => {
    let frm = [...data];

    let value = e.target.value;

    columns.map(col => {
      if (col.datafield == e.target.name) {
        value = value.replace(',', '.');

        if (value.includes('.')) {
          if (countSubstr(value, '.') > 1) {
            value = (value.replace(/[^0-9]/g, '') / 100);
          } else {
            value = value.replace(/[^0-9.]/g, '');
          }
        } else {
          value = value.replace(/[^0-9]/g, '');
        }

        // value = Number(value).toFixed(2);
        // if(col.currency){
        //   value = value.replace('R$ ',''); 
        //   value = value.replace(',','.');
        //   value = /[0-9,.]/
        // }

        // if(col.sufix !== ""){
        //   value = value.replace(col.sufix,'');
        //   value = value.replace(',','.');
        // }
      }
    })

    frm[idx][e.target.name] = value;

    setData(frm);    
  }

  const onChangeCB = (e, idx) => {
    let frm = [...data]

    let checked = e.target.checked;

    frm[idx].checked = checked;

    setData(frm);    
  }

  const onChangeCheckAll = (e) => {
    checkAll(e.target.checked);
  }

  const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "lightblue" : "lightgrey",
    padding: 8,
    width: 250
  });

  const onDragEnd = (e) => {
    // console.log(e)
    if(e.destination != null){
      let origIdx = e.source.index;
      let destIdx = e.destination.index;

      let newCol = [];
        
      let oldSource = columns[origIdx];
      let oldDest   = columns[destIdx];
  
      columns.map((col,i)=>{
        if(i != origIdx){
          newCol.push(col) 
        }
        // if(i == destIdx){
        //   newCol.push(oldSource);
        //   console.log(destIdx)
        //   // newCol.push(oldDest)
        //  }else 
        // if(i == positon){
        //   newCol.push(oldDest);
        //   console.log(positon)
        // }else if((origIdx < destIdx )&&(i != positon)){
        //   newCol.push(col)
        // }else{
        //   newCol.push(col)
        // }
        // console.log(col)
      }) 
      newCol.splice(destIdx,0,oldSource);   
      gravaPosicaoColunas(newCol);
      setColumn(newCol);     
    }  
  }

  return (
    <div className={'container-table'}>     
      {/* <DragDropContext onDragEnd={onDragEnd}>
        <Droppable 
          droppableId="droppable" 
          direction="horizontal"
        > */}
          {/* {(provided, snapshot) => ( */}
          <Row className="w-max-width">
            <div className="header-comment"></div>
            
            <div className="header-comment-digi text-center color-pr-digi">
              <span >Digifarma</span>
            </div>

            <div className="header-comment-digi text-center color-pr-categ">
              <span>Adicional Categoria</span>
            </div>

            <div className="header-comment-digi text-center color-pr-prod">
              <span>Adicional Produto</span>
            </div>

            <div className="header-comment-digi text-center color-pr-ecommerce">
              <span>E-Commerce</span>
            </div>

          </Row>
            
            <div
              // ref={provided.innerRef}            
              // style={getListStyle(provided.isDraggingOver)}              
              // {...provided.droppableProps}
              // {...provided.placeholder}
              // {...provided}
              className={'header-row'}
            >                 
              {/* <div > */}              
                { columns && columns.map((coluna, idx) =>{
                  if(coluna.visible == true){              
                    return(
                      // <Draggable key={idx} draggableId={`${idx}`} index={idx}>
                      //   {(provided, snapshot) => (
                          <div
                          // ref={provided.innerRef}
                          // {...provided.draggableProps}
                          // {...provided.dragHandleProps}  
                          key={`col-header${coluna.dataField != "" ? coluna.dataField : idx}`}
                              // className={'header-column-cell'}
                              // style={{width:coluna.width, textAlign: coluna.align}}                          
                          >                   
                            <div style={{width:coluna.width, textAlign: coluna.align}} className={'header-column-cell'}>                        
                            {coluna.checkbox &&
                              <input
                                type="checkbox"
                                onChange={onChangeCheckAll}
                              ></input>
                            }
                            {coluna.text}
                          </div>
                          </div>
                      //   )}
                      // </Draggable>
                    )
                  }
                }
                )}
              {/* </div> */}
              {/* {provided.placeholder}  */}
            </div>          
          {/* )} */}
        {/* </Droppable>
      </DragDropContext> */}

      {data && data.map((linha, idx) => {        
        if (((onlyChecked == true) && (linha.checked)) || (onlyChecked == false)) {          
          return (
            <div
              key={`row-grupo-${idx}`}
              className={'row-grupo row-data-grid ' + ((idx % 2 == 0) ? '' : 'row-color')}>
              <div
                key={`row-${idx}`}
                style={{ display: 'flex',}}
              >
                {columns.map((col, colIdx) =>
                col.visible == true &&
                  <div key={`group-col-${colIdx}`} className={col.bodyStyle && col.bodyStyle.className}>                        
                    {(col.editable && !readOnly && linha.checked) &&
                      <div
                        key={`col-${colIdx}`}
                        // className={[styles.columnCell,styles.rowColor]}
                        className={'column-cell edit-dtable'}
                        style={{ width: col.width, textAlign:col.align }}
                      >
                        <input
                          name={col.dataField}
                          value={((col.currency && linha[columns[colIdx].dataField] != "") ? 'R$ ' : '') + linha[columns[colIdx].dataField]}
                          className={"input-edit-dtable"}
                          style={{ textAlign: col.align }}
                          // onBlur={(e)=>{handleChangeInput(e,idx)}}
                          onChange={(e) => { onChangeInput(e, idx) }}
                        ></input>
                      </div>
                    }                    
                    {(!col.editable || readOnly || !linha.checked) &&
                      <div
                        key={`col-${colIdx}`}
                        // className={[styles.columnCell,styles.rowColor]}
                        className={'column-cell'}
                        style={{ width: col.width, textAlign: col.align }}
                      >
                        {col.checkbox && <input type="checkbox" onChange={(evt) => { onChangeCB(evt, idx) }} checked={linha.checked}></input>}
                        {col.currency && `R$ ${linha[columns[colIdx].dataField]}`}
                        {col.sufix && `${linha[columns[colIdx].dataField]} ${col.sufix}`}
                        {!col.sufix && !col.currency && linha[columns[colIdx].dataField]}
                      </div>
                    }
                  </div>
                )}
              </div>             
            </div>
          )
        }
      }
      )}
    </div>


    // <div className={styles.containerTable}>
    //   <table>
    //     <thead>
    //       <tr>
    //         {columns.map(coluna =>
    //           <th
    //             key={coluna.dataField}
    //             className={styles.headerColumnCell}>
    //             {coluna.text}
    //           </th>
    //         )}
    //       </tr>
    //     </thead>

    //     <tbody>
    //       {data.map((linha, idx) =>

    //         <tr
    //           key={`row${idx}`}
    //         >
    //           {columns.map((col, colIdx) =>
    //               <td
    //                 key={`col${colIdx}`}
    //                 className={[styles.columnCell]}
    //               >
    //                 <div>
    //                   <span style={{display:"block"}}>{linha[columns[colIdx].dataField]}</span>
    //                   {colIdx == 0 &&
    //                     <span style={{width:'200px',display:"block"}}>{linha.produto}</span>
    //                   }
    //                 </div>
    //               </td>
    //           )}
    //         </tr>

    //       )}
    //     </tbody>

    //   </table>
    // </div>
  )
}

export default DataTableEcommerce;